function SaveIcon() {
	return (
		<svg
			width="80"
			height="81"
			viewBox="0 0 80 81"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M44.5783 0.763696C55.7569 0.679886 68.2956 3.24012 74.6533 12.4351C80.5851 21.0142 74.4255 32.1264 73.4429 42.5101C72.6206 51.2012 74.7173 60.4207 69.4537 67.3854C63.5585 75.1859 54.3398 80.1441 44.5783 80.7034C34.2904 81.2928 24.2668 77.3817 16.6794 70.409C8.75335 63.1252 3.34064 53.2697 3.01736 42.5101C2.68497 31.447 7.14209 20.7264 14.951 12.8827C22.7769 5.02188 33.4864 0.846855 44.5783 0.763696Z"
				fill="#2ED7DB"
			/>
			<g clipPath="url(#clip0_390_58108)">
				<path
					opacity="0.4"
					d="M54.0566 33.7895C49.9868 29.2947 47.5683 25.3378 46.2559 22.8099C44.8345 20.0717 44.3687 18.3738 44.3651 18.3603L43.942 16.7607L42.431 17.4347C42.2544 17.5135 38.0794 19.4174 35.74 24.096C34.5657 26.4448 34.3308 29.0598 34.3407 30.8398C34.3464 31.8757 33.6125 32.7752 32.5956 32.9785C31.8826 33.121 31.1492 32.8993 30.6347 32.3848L27.82 29.57L26.8517 30.9052C26.7512 31.0438 24.3849 34.3072 23.9541 34.9592C21.8505 38.1437 20.7536 41.8531 20.782 45.6867C20.8201 50.8067 22.8336 55.6035 26.4515 59.1937C30.0692 62.7837 34.8814 64.7607 40.0017 64.7607C50.5997 64.7606 59.2217 56.1386 59.2217 45.5407C59.2218 41.6981 57.3391 37.415 54.0566 33.7895ZM40.0018 61.9458C35.6293 61.9458 31.5213 60.2588 28.4345 57.1956C25.3476 54.1323 23.6297 50.0375 23.5971 45.6658C23.5727 42.3931 24.5084 39.2273 26.303 36.511C26.5221 36.1794 27.401 34.9531 28.164 33.895L28.6443 34.3753C29.8258 35.5569 31.509 36.0667 33.1479 35.7389C35.4832 35.2718 37.1688 33.205 37.1558 30.8244C37.1476 29.3511 37.3323 27.2064 38.2579 25.3549C39.3847 23.1015 41.0691 21.6288 42.2395 20.8098C43.2982 23.5024 45.9817 29.0653 51.9699 35.679C53.3039 37.1524 56.4068 41.0628 56.4068 45.5408C56.4068 54.5864 49.0475 61.9458 40.0018 61.9458Z"
					fill="white"
				/>
				<path
					d="M42.8545 40.6416L34.0286 53.5665H37.149L45.9749 40.6416H42.8545Z"
					fill="white"
				/>
				<path
					d="M44.7378 46.5498C42.7807 46.5498 41.3035 47.8607 41.3035 50.1504C41.3035 52.4584 42.7806 53.7508 44.7378 53.7508C46.6951 53.7508 48.1722 52.4584 48.1722 50.1504C48.1722 47.8607 46.695 46.5498 44.7378 46.5498ZM44.7378 51.7567C44.3316 51.7567 43.9254 51.3874 43.9254 50.1503C43.9254 48.9132 44.3316 48.5438 44.7378 48.5438C45.144 48.5438 45.5502 48.9132 45.5502 50.1503C45.5502 51.3874 45.144 51.7567 44.7378 51.7567Z"
					fill="white"
				/>
				<path
					d="M38.7003 44.0575C38.7003 41.768 37.2232 40.457 35.2659 40.457C33.3087 40.457 31.8315 41.768 31.8315 44.0575C31.8315 46.3655 33.3087 47.658 35.2659 47.658C37.2232 47.658 38.7003 46.3655 38.7003 44.0575ZM34.4535 44.0575C34.4535 42.8204 34.8597 42.4511 35.2659 42.4511C35.6721 42.4511 36.0783 42.8204 36.0783 44.0575C36.0783 45.2946 35.6721 45.6639 35.2659 45.6639C34.8597 45.6639 34.4535 45.2946 34.4535 44.0575Z"
					fill="white"
				/>
			</g>
			<defs>
				<clipPath id="clip0_390_58108">
					<rect
						width="48"
						height="48"
						fill="white"
						transform="translate(16 16.7617)"
					/>
				</clipPath>
			</defs>
		</svg>
	);
}

export default SaveIcon;
